import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Upload, Button, Table} from 'antd'
import {UploadOutlined, ExclamationCircleFilled, DeleteOutlined} from '@ant-design/icons'
import moment from 'moment'
import md5 from 'js-md5'
import uuidv4 from 'uuid/v4'
import auth from '../../../utils/auth'
import alertMessage from '../../../utils/alertMessage'
import {withTranslation} from 'react-i18next'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
const storage = window.localStorage

@inject('emailAddressStore', 'accountStore')
@observer
class FormImport extends Component {
  formRef = React.createRef()
  beforeUpload = (file, FileList) => {
    return true
  }

  getHeader = () => {
    const authInfo = auth.getAuthInfo()
    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
    const uuid = uuidv4()
    const nounce = md5(timestamp + uuid)
    return {
      timestamp,
      uuid,
      nounce,
      Authorization: `Bearer ${authInfo.token}`
    }
  }

  onChange = (info) => {
    const {emailAddressStore, handleCancel} = this.props
    const {searchItem} = emailAddressStore
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      if (info.file.response.code !== 0) {
        alertMessage.error(info.file.response.messageEn)
      } else {
        emailAddressStore.onSearchJobAction(searchItem)
        handleCancel()
        alertMessage.success('导入成功!')
      }
    } else if (info.file.status === 'error') {
      alertMessage.error('导入失败!')
    }
  }

  handleExport = () => {
    // 创建隐藏的链接元素
    const link = document.createElement('a');
    link.href = '/地址.xlsx'; // 文件需要放在 public 目录下
    link.download = '地址.xlsx'; // 设置下载文件名
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  render() {
    const {emailAddressStore, importModalVisible, handleCancel, record, t} = this.props
    const {detailsObj, searchItem} = emailAddressStore
    const {Dragger} = Upload
    const UPLOAD_TEMPLATE_URL = `${window.g.apiBaseUrl}/market/management/email/fileImport`
    const jobList =[
      {
        id: 0,
        '邮件地址': 'user1@domain.com',
        '姓名': '姓名1', 
        '性别': '男', 
        '生日': '1987/8/8', 
        '手机': '185****1234', 
        '地区': '地区', 
        '变量1': '变量1', 
        '变量2': '变量2', 
        '变量3': '', 
        '变量4': ''
      },
      {
        id: 0,
        '邮件地址': 'user2@domain.com',
        '姓名': '姓名2', 
        '性别': '女', 
        '生日': '1987/8/8', 
        '手机': '185****1234', 
        '地区': '地区', 
        '变量1': '变量1', 
        '变量2': '变量2', 
        '变量3': '变量3', 
        '变量4': '变量4'
      },
    ]
    const columns = ['邮件地址', '姓名', '性别', '生日', '手机', '地区', '变量1', '变量2', '变量3', '变量4']

    return (
      <>
        <Modal
          title={t(`emailSend.addAddressTit`)}
          // closable={false}
          visible={importModalVisible}
          onCancel={() => { handleCancel('importModalVisible') }}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={null}
          width={'80%'}
        >
          <div>文件格式说明: <Button type="link" onClick={this.handleExport} style={{color: '#1371FF'}}>下载模板</Button></div>
          <Table className="searchResult" dataSource={jobList} rowKey="id" style={{padding: 0}} rowClassName={this.getRowClassName} pagination={false}>
            {columns.map(a=> {
                return <Table.Column title={a} dataIndex={a} key={a} ellipsis={true} />
            })}
            {/* <Table.Column width={200} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
              <>
                <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
              </>
            )}/> */}
          </Table>
          <div className='tips_box' style={{marginTop: 10}}>
            <div><ExclamationCircleFilled /> 文件中一个地址占一行，每个邮件可以另外有10个变量；每个变量支持最长100个字符。 要导入的文件大小不能超过 20MB，大于 20MB 的文件请切割后分批导入。 地址导入时会进行地址合法性检测、有效性检测和重复性检测</div>
          </div>
          <Dragger
            accept=".xlsx"
            action={UPLOAD_TEMPLATE_URL}
            headers={this.getHeader()}
            style={{width: '100%', margin: '0 auto'}}
            onChange={this.onChange}
            data={{
              marketGroupId: searchItem?.marketGroupId,
              listId: record?.id
            }}
            beforeUpload={this.beforeUpload}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined style={{color: '#031a34'}}/>
            </p>
            <p className="ant-upload-text">{t(`dataTarget.dragFile`)}</p>
            <p className="ant-upload-hint" style={{ marginBottom: '10px' }}>
              支持文件格式(*.xlsx;)，文件最大允许20M。
            </p>
          </Dragger>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormImport)
